import { Navigate } from "react-router-dom";

export default function AgenteContabilidadeRedirect() {
  return <Navigate to="/agentecontabilidade/visao-geral" replace />;
}

